/*
 * This module will call the form certifier 3rd party
 * called ActiveProspect. For details:
 * https://developers.activeprospect.com/docs/trustedform/overview/.
 * When executed, a set of inputs will be submitted in every
 * lead, so we can post a secret token that confirms the
 * authenticity of the lead in terms of the 3rd party.
 * These inputs will contain Ids that are used to give
 * traceability to the leads requested from NHS and make sure
 * they come from a real user.
 */
(function handlerTrustedForm(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  const queryScript = 'nhs_scriptTrustedForm';
  const eventToAttach = Object.prototype.hasOwnProperty.call(global, 'ontouchstart') ? 'touchend' : 'mousedown';

  /**
   * @constructs NewHomeSource.TrustedForm
   */
  function TrustedForm() {
  }

  /**
   * @private
   * attachEvent: attach event to load script.
   *
   * @param {Event} event with the information of current target.
   */
  function attachEvent(event) {
    if (event.target.dataset.trustedForm) {
      TrustedForm.load();
    }
  }

  /**
   * @private
   * executeMethod: observe when input on form is already in the DOM to make the request.
   *
   * @param {Function} callback to be executed when  trusted form is ready.
   */
  function executeMethod(callback) {
    const xxTrustedFormCertUrl = document.querySelector("[name='xxTrustedFormCertUrl']");
    if (xxTrustedFormCertUrl) {
      callback();
    } else {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (!mutation.addedNodes) { return; }

          for (let i = 0; i < mutation.addedNodes.length; i += 1) {
            if (mutation.addedNodes[i].id === 'xxTrustedFormCertUrl_0') {
              observer.disconnect();
              callback();
              break;
            }
          }
        });
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false
      });
    }
  }

  /**
   * @private
   * load: download the script of trusted form
   *
   * @param {Function} callback to be executed after all is ready.
   */
  TrustedForm.load = function (callback) {
    if (document.querySelector('#' + queryScript)) {
      if (typeof callback === 'function') {
        callback();
      }
      return;
    }
    const field = 'xxTrustedFormCertUrl';
    const provideReferrer = false;
    const invertFieldSensitivity = false;
    const tf = document.createElement('script');
    tf.type = 'text/javascript';
    tf.async = true;
    tf.id = queryScript;
    tf.src = document.location.protocol + '//api.trustedform.com/trustedform.js?provide_referrer=' +
      escape(provideReferrer) + '&field=' + escape(field) + '&l=' + new Date().getTime() + Math.random() +
      '&invert_field_sensitivity=' + invertFieldSensitivity;
    document.head.appendChild(tf);

    if (typeof callback === 'function') {
      tf.addEventListener('load', executeMethod.bind(this, callback));
    }
  };

  global.NewHomeSource.TrustedForm = TrustedForm;
  document.addEventListener(eventToAttach, attachEvent);

  return TrustedForm;
}(window));
